import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { DEFAULT_LOCALE, MAX_DATE, MIN_DATE } from '../../common-constants';

@Pipe({
  name: 'customDate',
  standalone: true,
})
export class CustomDatePipe implements PipeTransform {
  transform(value: unknown, format: string = 'mediumDate', locale: string = DEFAULT_LOCALE): string {
    const datePipe = new DatePipe(locale);
    if (!value) {
      return '';
    }

    const inputDate = value instanceof Date ? value : new Date(value as string | number);
    if (inputDate <= MIN_DATE) {
      return '-';
    }
    if (inputDate >= MAX_DATE) {
      return 'NA';
    }

    const formattedValue = datePipe.transform(value as string | number | Date, format);
    if (formattedValue === null) {
      throw new Error('DatePipe returned null for a non-empty value.');
    }

    return formattedValue;
  }
}
